// extracted by mini-css-extract-plugin
export default {"impermaxInput":"impermax-input_impermaxInput__41Feq"};